export default __webpack_public_path__ + "static/media/timer-alert.bc0eb7e8.svg";